// extracted by mini-css-extract-plugin
module.exports = {"price":"a10a3f92e9--price--c1gyM","subtext":"a10a3f92e9--subtext--3lyLg"};